// utils
import type { TSessionByChannel } from '@newo/api/gateway';
import { round } from 'es-toolkit';
import EmptyView from '@/pages/Report/components/EmptyView';

interface ByChannelProps {
    className?: string;
    data?: TSessionByChannel[];
}

const PERCENTAGE_MULTIPLIER = 100;

const ByChannel = ({ className, data }: ByChannelProps) => {
    const items = data ?? [];

    // Calculate total sessions across all channels
    const totalSessions = items.reduce((sum, item) => sum + item.count, 0);

    return (
        <div className={className}>
            <div className="font-semibold mb-1">by Channel</div>

            {items.length === 0 && <EmptyView className="h-80" />}
            {items.length > 0 && (
                <div className="divide-y divide-x-0 divide-gray-3 divide-solid">
                    {items.map(({ channel, count }) => {
                        // Calculate percentage for each channel
                        const percentage =
                            totalSessions > 0
                                ? round(
                                      (count / totalSessions) *
                                          PERCENTAGE_MULTIPLIER
                                  )
                                : 0;

                        return (
                            <div
                                className="flex justify-between capitalize py-2 nw-format-number"
                                key={channel}
                            >
                                <span>{channel}</span>
                                <span>
                                    {count} ({percentage}%)
                                </span>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default ByChannel;
